import { Divider, Form, InputNumber } from 'antd';
import classnames from 'classnames';

import { SwitchableInput } from 'app/components/commons/SwitchableInput/SwitchableInput';
import { parseInputNumber } from 'app/utils/typing';

import styles from '../RoomDiscount.module.scss';
import {
  ROOM_DISCOUNT_OVER_MAX_MESSAGE,
  isRoomDiscountOverMax,
  maxRoomDiscountRule,
} from '../roomDiscountRules';

import { RevenueShare } from './RevenueShare';

type LastMinuteDiscountSectionProps = {
  currencyFormatter: (value: number) => string;
  formRoomPrice?: number | null;
  disabled: boolean;
  lastMinuteNightRoomDiscountRate?: number | null;
  isLastMinuteEnabled: boolean;
  onLastMinuteToggle: (value: boolean) => void;
};

export const LastMinuteDiscountSection = ({
  currencyFormatter,
  formRoomPrice,
  disabled,
  lastMinuteNightRoomDiscountRate,
  isLastMinuteEnabled,
  onLastMinuteToggle,
}: LastMinuteDiscountSectionProps) => (
  <div className={styles.wrapper}>
    <div className={styles.discountTitleWrapper}>
      <p className={styles.discountTitle}>LAST MINUTE DISCOUNT</p>
    </div>
    <div
      className={classnames(
        styles.switchableWrapper,
        styles.discountModeWrapper
      )}
    >
      <SwitchableInput
        title={
          <div className={styles.discountTitleWrapper}>
            <p className={styles.switchTitle}>Last minute discount</p>
          </div>
        }
        disabled={disabled}
        value={isLastMinuteEnabled}
        onChange={onLastMinuteToggle}
        childNode={
          <>
            <Divider className={styles.lastMinuteDivider} />
            <div className={styles.rowBody}>
              <div className={styles.discountRow}>
                <span>From</span>
                <div className={styles.discountInput}>
                  <Form.Item noStyle name="lastMinuteNightRoomDiscountDays">
                    <InputNumber
                      min={0}
                      parser={parseInputNumber}
                      disabled={!isLastMinuteEnabled}
                    />
                  </Form.Item>
                </div>
                <span>days before check-in apply a discount of</span>
                <div className={styles.discountRateInput}>
                  <Form.Item
                    noStyle
                    name="lastMinuteNightRoomDiscountRate"
                    rules={[maxRoomDiscountRule]}
                  >
                    <InputNumber
                      min={0}
                      max={100}
                      addonAfter="%"
                      parser={parseInputNumber}
                      disabled={!isLastMinuteEnabled}
                      status={
                        isRoomDiscountOverMax(lastMinuteNightRoomDiscountRate)
                          ? 'error'
                          : ''
                      }
                    />
                  </Form.Item>
                  {isRoomDiscountOverMax(lastMinuteNightRoomDiscountRate) && (
                    <span className={styles.errorMessage}>
                      {ROOM_DISCOUNT_OVER_MAX_MESSAGE}
                    </span>
                  )}
                  {isLastMinuteEnabled && !formRoomPrice && (
                    <span className={styles.errorMessage}>
                      Average BAR required to calculate revenue share
                    </span>
                  )}
                  {isLastMinuteEnabled &&
                    formRoomPrice &&
                    lastMinuteNightRoomDiscountRate !== null &&
                    lastMinuteNightRoomDiscountRate !== undefined &&
                    lastMinuteNightRoomDiscountRate > 0 && (
                      <div className={styles.pricePreview}>
                        <span className={styles.description}>
                          Estimated room revenue share =
                        </span>{' '}
                        <RevenueShare
                          currencyFormatter={currencyFormatter}
                          basePrice={formRoomPrice}
                          discountPercent={lastMinuteNightRoomDiscountRate}
                        />
                      </div>
                    )}
                </div>
                <span>to all rooms within packages</span>
              </div>
            </div>
          </>
        }
        noBorder
        noPadding
      />
    </div>
  </div>
);
